import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page50() {
  useEffect(() => {
    document.title = "Маяк — Страница 49"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page48" />
        <ForwardLink href="/page50" />
      </div>

      <p style={{ textAlign: "right" }}>49.</p>
      <p>ВОЛНА РУШИТСЯ И ПАДАЕТ...</p>
      <p>
        СТАРИК улыбается сам себе. <i>"Я все еще умею это",</i> – думает он. Делает<br/>
        глоток из бутылки...
      </p>
      <p>Действительно ли он заставил волну упасть? Или это совпадение?</p>
      <p>В любом случае, ветер возвращается с местью ...</p>
      <p>
        Позади него привязанная ДОРИ (спасательная лодка) раскачивается на ветру,<br/>
        ударясь о борта лодочного сарая.
      </p>
      <p>Звук фогорна. Мигает свет.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        (поет “Blood Red<br/>
        Roses”)<br/>
        <i>Это мороз, снег и зимняя<br/>
        буря.</i><br/>
        (хлопок)<br/>
        <i>Падайте, кроваво-красные розы,<br/>
        падайте!</i><br/>
        (хлопок)<br/>
        <i>И много кораблей потерялось<br/>
        у мыса Горн.</i><br/>
        (хлопок)<br/>
        <i>Падайте, кроваво-красные розы,<br/>
        падайте!</i><br/>
        (хлопок)<br/>
        <i>Ох, гвоздики и букеты...</i> ВОСЕМЬ...<br/>
        <i>Падайте!</i>
      </p>
      <p>ДЕВЯТЬ! Он крестится. Обливает море.</p>
      <p>Он прекращает петь и кричит:</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        УГАСАЙТЕ, О ВОЛНЫ ОТЦА<br/>
        НЕПТУНА! Я УМОЛЯЮ ВАС! ПЕЙТЕ ЭТО<br/>
        ПРИНОШЕНИЕ, УТОЛИТЕ ЖАЖДУ И УГАСАЙТЕ!<br/>
      </p>
      <p>
        Он выливает еще немного ликера в море и сам делает еще один<br/>
        глоток.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        (поет)<br/>
        <i>Ну, капитан он пришел<br/>
        со страхом.<br/>
        Падайте --</i>
      </p>
      <p>
        ВНЕЗАПНО ОГРОМНАЯ ВОЛНА ОБРУШИВАЕТСЯ НА СТАРИКА, СБИВАЯ ЕГО<br/>
        С НОГ.
      </p>
      <p>ОН ПЫТАЕСЯ ВСТАТЬ, ПЕРЕВЕСТИ ДЫХАНИЕ...</p>
      <p style={{ textAlign: "right" }}>49.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page48" />
        <ForwardLink href="/page50" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710316006/the-lighthouse-script/ez1yuliwf4idcxzrhtrc.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page50;
